import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useMutation, useQueryClient } from 'react-query';
import { OrganizationKeys } from './organization.keys';

export const useAddOrganizationLicenses = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ organizationId, licenses }: { organizationId: string; licenses: string[] }) =>
      clients.admin.post(`/organizationlicenses/multi/${organizationId}`, licenses),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: OrganizationKeys.orgLicensesCollections(),
        });
      },
    },
  );
};
